import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { DateTimeInput, Input, Select } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

export const formName = 'subscriptionCancellation';
export const selector = formValueSelector(formName);

// a cancellation the parent asked for by phone, email or in person
const RecordSubscriptionCancellationForm = ({ error, handleSubmit, cancellationRequestChannels, preview, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Alert bsStyle='info'>{t('PaymentHistory_Subscription_RecordCancellationHelp')}</Alert>
			<Select name='channel' data={cancellationRequestChannels} horizontal required label={t('PaymentHistory_Subscription_Channel')} validate={validators.required} />
			<Field name='requestedAt' component={DateTimeInput} showTime={true} horizontal required label={t('PaymentHistory_Subscription_RequestedAt')}
				validate={validators.required} help={t('PaymentHistory_Subscription_RequestedAtHelp')} />
			<Field name='notes' component={Input} componentClass='textarea' horizontal label={t('PaymentHistory_Subscription_RequestNotes')} />
			{preview && <Alert bsStyle='warning'>
				<div>{preview.withinCoolingOff ? t('PaymentHistory_Subscription_Preview_CoolingOff', { refund: preview.refundAmount })
					: t('PaymentHistory_Subscription_Preview_LastDay', { date: preview.lastDay })}</div>
				<div>{preview.owedPayments.length > 0
					? t('PaymentHistory_Subscription_Preview_OwedPayments', { payments: preview.owedPayments.map(x => `${x.amount} (${x.chargeDate})`).join(', ') })
					: t('PaymentHistory_Subscription_Preview_NoMorePayments')}</div>
			</Alert>}
		</Form>
	);
};

export default reduxForm({ form: formName })(withTranslation()(RecordSubscriptionCancellationForm));
